export default __webpack_public_path__ + "static/media/17.c5be7253.jpg";